import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from 'react-i18next'
import { toast, ToastContainer } from 'react-toastify'; // Import ToastContainer
import 'react-toastify/dist/ReactToastify.css';
import './archive.css';

const Archivio = () => {
  const { t, i18n } = useTranslation();

  const [files, setFiles] = useState([]);
  const [uploadFile, setUploadFile] = useState(null);
  const [sharedWith, setSharedWith] = useState([]);
  const [users, setUsers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("");

  const token = localStorage.getItem("token"); // JWT
  ;

  // Carica dati iniziali
  useEffect(() => {
    fetchFiles();
    fetchUsers();
    fetchTeams();
  }, []);

  // Lista file visibili
  const fetchFiles = async () => {
      const token = localStorage.getItem("token"); // assicuriamoci che il token sia corretto
      if (!token) {
        console.error("Token mancante!");
        return;
      }
      try {
        const res = await axios.get("https://www.hat.sofhare.com/elaborazioni/", {
          headers: { Authorization: `Bearer ${token}` },
        });

        const sorted = res.data.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setFiles(sorted);
      } catch (err) {
       toast.error("Errore caricamento file esistenti!", { autoClose: 2000 });
      }
    };

  // Lista utenti con cui posso condividere
  const fetchUsers = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await axios.get("https://www.hat.sofhare.com/elaborazioni/shareable-users/", {
          headers: { Authorization: `Bearer ${token}` },
        });

        console.log("fetchUsers response data:", res.data);
        setUsers(res.data);
      } catch (err) {
        toast.error("Errore caricamento utenti!", { autoClose: 2000 });
      }
    };

    const fetchTeams = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await axios.get("https://www.hat.sofhare.com/elaborazioni/teams/", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTeams(res.data);
      } catch (err) {
        toast.error("Errore caricamento team!", { autoClose: 2000 });
      }
    };

  // Upload file
  const handleUpload = async (e) => {
      e.preventDefault();
      if (!uploadFile) return;
      const formData = new FormData();
      formData.append("file", uploadFile);
      // aggiungi team_id solo se selezionato
      if (selectedTeam) {
        formData.append("team_id", selectedTeam);
      }
      // aggiungi utenti con cui condividere
      sharedWith.forEach((id) => formData.append("shared_with", id));
      try {
        const response = await axios.post(
          "https://www.hat.sofhare.com/elaborazioni/upload/",
          formData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        // reset stato
        setUploadFile(null);
        setSharedWith([]);
        setSelectedTeam("");
        // ricarica lista file
        fetchFiles();
        toast.success("File caricato", { autoClose: 1000 });
      } catch (err) {
        toast.error("Errore upload file!", { autoClose: 2000 });
      }
    };

  // Download file
const handleDownload = async (fileId, fileName) => {
  try {
    // 1) controlla che il token sia valido
    if (!token) {
      console.error("Token non disponibile. Attendere login completato.");
      return;
    }

    // 2) effettua la richiesta al backend
    const response = await axios.get(
      `https://hat.sofhare.com/elaborazioni/${fileId}/download/`,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      }
    );

    // 3) se la risposta non è un blob valido, interrompi
    if (!response.data || response.data.type === "text/html") {
      console.error("Download non valido: possibile errore o HTML ricevuto.");
      return;
    }

    // 4) crea URL ed effettua il download
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Errore download:", error);
  }
};

    // Delete file
    const handleDelete = async (fileId, fileName) => {
      const confirmDelete = window.confirm(
        `Vuoi eliminare il file "${fileName}"?`
      );
      if (!confirmDelete) return;
      try {
        await axios.delete(
          `https://www.hat.sofhare.com/elaborazioni/${fileId}/delete/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // rimuove subito dalla UI
        setFiles((prev) => prev.filter((f) => f.id !== fileId));
         toast.success("File eliminato!", { autoClose: 2000 });
      } catch (err) {
          toast.error("Errore cancellazione file!", { autoClose: 2000 });
        }
            };

  return (

    <div className="main-wrapper">

      <div className="tools-wrapperS1-arch">
          <h1 className="archivio-title">Carica file</h1>

          <form onSubmit={handleUpload} className="upload-form">

            <div className="upload-row">

              {/* ===== COLONNA SINISTRA ===== */}
              <div className="upload-col-left">
                {/* Seleziona Team */}
                <label className="form-label"> Seleziona Team
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="download-icon-inp">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
                    </svg>
                </label>
                <select className="form-element" value={selectedTeam} onChange={e => setSelectedTeam(e.target.value)}>
                  <option value="">Nessuno</option>
                  {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                </select>

                {/* Condividi con utenti */}
                <label className="form-label">Condividi
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="download-icon-inp">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
                </svg>
                </label>
                <select className="form-element" multiple value={sharedWith} onChange={e => setSharedWith(Array.from(e.target.selectedOptions, opt => opt.value))}>
                  {users.map(u => <option key={u.id} value={u.id}>{u.username}</option>)}
                </select>

                {/* File input */}
                <label className="file-input">
                  {uploadFile ? uploadFile.name : "Scegli file"}
                  <input type="file" onChange={e => setUploadFile(e.target.files[0])} />
                  
                </label>

                {/* Bottone Invia */}
                <button type="submit" className="file-input">
                 Carica
                </button>
              </div>

              {/* ===== COLONNA DESTRA ===== */}
              <div className="upload-col-right">
                <h1 className="archivio-title">Archivio</h1>
                  <p>L’archivio ti permette di gestire i file che hai caricato o che ti sono stati condivisi.
                  </p>
                  <p>Puoi:</p>
                  <ul>
                    <li>Scaricare, caricare o eliminare le elaborazioni.</li>
                    <li>Visualizzare i tuoi file e quelli condivisi dai team di cui fai parte.</li>
                    <li>Condividere le elaborazioni con altri utenti.</li>
                  </ul>
                  <p>
                    Per creare nuovi gruppi o decidere con chi condividere i file,
                    contatta direttamente <a href="mailto:umberto.grechi@sofhar.com">umberto.grechi@sofhar.com</a>.
                  </p>
              </div>
            </div>
          </form>
        </div>

      {/* ===== SEZIONE DESTRA (ARCHIVIO FILE) ===== */}
      <div className="tools-wrapperS1-arch">

        <table className="files-table">
          <thead>
            <tr>
              <th>File</th>
              <th>Team</th>
              <th>Caricato da</th>
              <th>Data caricamento</th>
              <th>Download</th>
              <th>Elimina</th>
            </tr>
          </thead>

          <tbody>
            {files.map((f) => (
              <tr key={f.id}>
                <td>{f.file}</td>
                <td>{f.team || "Personale"}</td>
                <td>{f.owner}</td>
                <td>{new Date(f.created_at).toLocaleString()}</td>
                <td>
                  <button onClick={() => handleDownload(f.id, f.file)}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="download-icon">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                    </svg>
                  </button>
                </td>
                <td>
                 <button onClick={() => handleDelete(f.id, f.file)}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="download-icon">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

      </div>
    </div>
  );
};

export default Archivio;